import React, { useEffect, useState } from "react";
import "./sidebar.css";
import { CgMenuGridR } from "react-icons/cg";
import { IoIosPeople } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { BsBuilding } from "react-icons/bs";
import { GiWorld } from "react-icons/gi";
import { BiWorld, BiLogOut, BiTask } from "react-icons/bi";
import { FaChartPie, FaUsersCog } from "react-icons/fa";
import { FcOvertime } from "react-icons/fc";
import { FiChevronDown, FiChevronRight } from "react-icons/fi";
import { GoCalendar } from "react-icons/go";
import { TbWorld } from "react-icons/tb";
import HoverSidebar from "./hoverSidebar/hoverSidebar";
import { Store } from "../../Redux/store";
import { sidebarTabs } from "../../Redux/Actions/sidebarButtons";

const SidebarTab = ({ id, label, Icon, selected, onClick, children }) => (
  <div className={selected ? "sidebar-tab-container" : "inactive"}>
    <div className="sidebar-tab-box">
      <Icon className="sidebar-icon" />
      <span>{label}</span>
    </div>
    {children}
    <div className="butn-cover" id={id} onClick={onClick} />
  </div>
);

const Sidebar = ({ urole, menus }) => {
  const navigate = useNavigate();
  const [tabs, setTabs] = useState([
    { value: "dashboard", selected: true },
    { value: "employee", selected: false },
    { value: "role", selected: false },
    { value: "kpi", selected: false },
    { value: "department", selected: false },
    { value: "region", selected: false },
    { value: "country", selected: false },
    { value: "performance", selected: false },
    { value: "task", selected: false },
    { value: "leave", selected: false },
    { value: "time", selected: false },
    { value: "website", selected: false },
    { value: "logout", selected: false },
  ]);
  const [menu, setMenu] = useState(false);
  const [opensubmenu, setOpensubmenu] = useState(false);
  const [hoverclicked, setHoverclicked] = useState(false);

  useEffect(() => {
    setMenu(!menu);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menus]);

  const handleClick = (e) => {
    setOpensubmenu(true);

    const id = e.target.id;
    if (id !== "logout") {
      Store.dispatch(sidebarTabs(id));
    } else {
      navigate("/");
    }

    setTabs((prevTabs) =>
      prevTabs.map((tab) =>
        tab.value === id
          ? { ...tab, selected: true }
          : { ...tab, selected: false }
      )
    );
  };

  const handleMouseEnter = () => {
    setOpensubmenu(true);
    setHoverclicked(true);
  };

  const handleMouseLeave = () => {
    setOpensubmenu(false);
    setHoverclicked(false);
  };

  const handleMouseDown = () => {
    // setHoverclicked(hoverclicked);
  };

  return (
    <div
      onClick={() => setMenu(!menu)}
      className={menu ? "sidebar-main-container-alt" : "sidebar-main-container"}
    >
      <div className={menu ? "sidebar-container" : "sidebar-container-alt"}>
        <div className="sidebar-tab-container-head">
          <div className="sidebar-tab-left" />
          <div className="sidebar-tab-right">
            <span>{urole.designation}</span>
            <span>{`${urole.fname} ${urole.lname}`}</span>
          </div>
        </div>

        <div className="sidebar-tabs-container">
          <SidebarTab
            id="dashboard"
            label="Dashboard"
            Icon={CgMenuGridR}
            selected={tabs.find((tab) => tab.value === "dashboard").selected}
            onClick={handleClick}
          />

          {urole.role === "H" && (
            <SidebarTab
              id="task"
              label="Smart Task"
              Icon={BiTask}
              selected={tabs.find((tab) => tab.value === "task").selected}
              onClick={handleClick}
            />
          )}

          {urole.role === "HR" && (
            <>
              <SidebarTab
                id="employee"
                label="Employees"
                Icon={IoIosPeople}
                selected={tabs.find((tab) => tab.value === "employee").selected}
                onClick={handleClick}
              />
              <SidebarTab
                id="role"
                label="Job Roles"
                Icon={FaUsersCog}
                selected={tabs.find((tab) => tab.value === "role").selected}
                onClick={handleClick}
              />
            </>
          )}

          {(urole.role === "MANAGER" || urole.role === "ADMIN") && (
            <SidebarTab
              id="kpi"
              label="KPI"
              Icon={FaUsersCog}
              selected={tabs.find((tab) => tab.value === "kpi").selected}
              onClick={handleClick}
            />
          )}

          {urole.role === "H" && (
            <>
              <SidebarTab
                id="leave"
                label="Leave Manager"
                Icon={GoCalendar}
                selected={tabs.find((tab) => tab.value === "leave").selected}
                onClick={handleClick}
              />
              <SidebarTab
                id="time"
                label="Time & Attendance"
                Icon={FcOvertime}
                selected={tabs.find((tab) => tab.value === "time").selected}
                onClick={handleClick}
              />
            </>
          )}

          {urole.role === "HR" && (
            <>
              <SidebarTab
                id="department"
                label="Department"
                Icon={BsBuilding}
                selected={
                  tabs.find((tab) => tab.value === "department").selected
                }
                onClick={handleClick}
              />
              <SidebarTab
                id="region"
                label="Region"
                Icon={GiWorld}
                selected={tabs.find((tab) => tab.value === "region").selected}
                onClick={handleClick}
              />
              <SidebarTab
                id="country"
                label="Country"
                Icon={BiWorld}
                selected={tabs.find((tab) => tab.value === "country").selected}
                onClick={handleClick}
              />
            </>
          )}

          {(urole.role === "ADMIN" || urole.role === "HR") && (
            <SidebarTab
              id="website"
              label="Website"
              Icon={TbWorld}
              selected={tabs.find((tab) => tab.value === "website").selected}
              onClick={handleClick}
            >
              <div
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                onMouseDown={handleMouseDown}
              >
                {hoverclicked ? (
                  <FiChevronDown id="sidebar-icons" />
                ) : (
                  <FiChevronRight id="sidebar-icons" />
                )}
                {(opensubmenu || hoverclicked) && (
                  <HoverSidebar
                    onmouseLeave={handleMouseLeave}
                    clickedbutn={(clickedtab) =>
                      Store.dispatch(sidebarTabs(clickedtab))
                    }
                  />
                )}
              </div>
            </SidebarTab>
          )}

          <SidebarTab
            id="performance"
            label="Performance"
            Icon={FaChartPie}
            selected={tabs.find((tab) => tab.value === "performance").selected}
            onClick={handleClick}
          />

          <SidebarTab
            id="logout"
            label="Logout"
            Icon={BiLogOut}
            selected={tabs.find((tab) => tab.value === "logout").selected}
            onClick={handleClick}
          />
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
